// src/shared/pickers.js — избор на контакт и масови действия (копия от app.js).
// Legacy копията остават в app.js за немигрираните екрани (фактури/проформи/контакти).

import { el, clear, input } from './dom.js';
import { api } from './api.js';
import { toast } from './toast.js';
import { confirmDialog } from './modal.js';
import { state } from './state.js';

export function contactPicker(contacts, hidden) {
  const sel = contacts.find((c) => String(c.id) === String(hidden.value));
  const search = input({ type: 'search', placeholder: 'Търси клиент по име или ЕИК…', value: sel ? sel.name : '' });
  const list = el('div', { style: 'display:none;position:absolute;z-index:60;left:0;right:0;background:var(--surface,#fff);border:1px solid var(--border);border-radius:8px;max-height:240px;overflow:auto;box-shadow:0 8px 24px rgba(0,0,0,.15)' });
  // (Г.3) Уловката: човек ИЗПИСВА името, не кликва ред — полето показва
  // текст, а скритият избор е празен и документът се записваше „без клиент".
  // При излизане с текст без избор полето се огражда и казва какво липсва.
  const warn = el('div', { class: 'picker-warn', text: 'Изберете клиент от списъка — изписаното име не е избор.' });
  warn.style.display = 'none';
  function syncWarn() {
    const dangling = !hidden.value && search.value.trim() !== '';
    search.classList.toggle('bad', dangling);
    warn.style.display = dangling ? '' : 'none';
  }
  // „change" по скритото поле — формата може да реагира на избора (напр.
  // „последна цена за този клиент" под редовете на проформата).
  function pick(c) { hidden.value = c ? String(c.id) : ''; search.value = c ? (c.name || '') : ''; list.style.display = 'none'; syncWarn(); hidden.dispatchEvent(new Event('change', { bubbles: true })); }
  function render(q) {
    clear(list);
    const ql = (q || '').toLowerCase().trim();
    const items = contacts.filter((c) => !ql || ((c.name || '') + ' ' + (c.eik || '')).toLowerCase().includes(ql)).slice(0, 60);
    list.appendChild(el('div', { style: 'padding:7px 10px;cursor:pointer;color:var(--muted)', onMouseDown: (e) => { e.preventDefault(); pick(null); } }, '— без клиент —'));
    items.forEach((c) => list.appendChild(el('div', { style: 'padding:7px 10px;cursor:pointer', onMouseDown: (e) => { e.preventDefault(); pick(c); }, onMouseOver: (e) => { e.currentTarget.style.background = 'var(--surface-2,#f3f4f6)'; }, onMouseOut: (e) => { e.currentTarget.style.background = ''; } },
      el('div', { style: 'font-weight:600', text: c.name || '' }), c.eik ? el('div', { style: 'font-size:12px;color:var(--muted)', text: 'ЕИК: ' + c.eik }) : null)));
    if (!items.length) list.appendChild(el('div', { style: 'padding:8px 10px;color:var(--muted)', text: 'Няма съвпадение' }));
    list.style.display = '';
  }
  search.addEventListener('focus', () => render(search.value));
  search.addEventListener('input', () => { hidden.value = ''; render(search.value); });
  // Изчакването пуска клика по реда да мине ПРЕДИ проверката (mousedown
  // избира; 150 ms е животът на списъка).
  search.addEventListener('blur', () => setTimeout(() => { list.style.display = 'none'; syncWarn(); }, 150));
  return el('div', { style: 'position:relative' }, search, list, hidden, warn);
}

// Автодовършване за поле „Доставчик" (протоколи): търси в контактите по име/ЕИК/ДДС
// и попълва наименование, ДДС № и държава. f = обектът с полетата на формата.
export function bulkManager(opts) {
  const isAdmin = state().user && state().user.role === 'admin';
  const selected = new Set();
  const rowCbs = [];
  const delBtn = el('button', { class: 'btn sm danger', style: 'display:none', text: 'Изтрий избраните', onClick: async () => {
    if (!selected.size) return;
    if (!(await confirmDialog('Да изтрия ли избраните ' + selected.size + ' ' + (opts.label || 'записа') + '? Действието е необратимо.', { okText: 'Изтрий', danger: true }))) return;
    let ok = 0, fail = 0;
    for (const id of Array.from(selected)) { try { await api(opts.endpoint + '/' + id, { method: 'DELETE' }); ok++; } catch (e) { fail++; } }
    toast('Изтрити: ' + ok + (fail ? (', грешки: ' + fail) : ''));
    opts.refresh();
  } });
  let statusSel = null;
  if (opts.statuses) {
    statusSel = el('select', { style: 'display:none;padding:5px 8px;border-radius:8px;border:1px solid var(--border)', onChange: async (e) => {
      const v = e.target.value; e.target.value = '';
      if (!v) return;
      if (!selected.size) { toast('Изберете поне един ред.', true); return; }
      // Смяната на статус НЕ е изтриване: неутрален бутон „Промени".
      // Етикетът идва от повикващия екран (фактури/проформи).
      if (!(await confirmDialog('Да сменя ли статуса на ' + selected.size + ' ' + (opts.label || 'записа') + ' на „' + opts.statuses[v][0] + '"?', { okText: 'Промени' }))) return;
      let ok = 0, fail = 0;
      for (const id of Array.from(selected)) { try { await api(opts.endpoint + '/' + id + '/status', { method: 'PATCH', body: JSON.stringify({ status: v }) }); ok++; } catch (err) { fail++; } }
      toast('Обновени: ' + ok + (fail ? (', грешки: ' + fail) : ''));
      opts.refresh();
    } }, el('option', { value: '', text: 'Смени статус на…' }), ...Object.keys(opts.statuses).map((k) => el('option', { value: k, text: opts.statuses[k][0] })));
  }
  // Други масови действия на екрана (артикули: група, вид, активни; доставки:
  // потвърди, ZIP). Бутонът казва колко реда ще пипне — изборът иначе е
  // невидим, щом списъкът е дълъг. run(ids) прави работата и сам казва резултата.
  const actionBtns = (opts.actions || []).map((a) => {
    const b = el('button', { class: 'btn sm ghost bulk-action', type: 'button', style: 'display:none', onClick: async () => {
      if (!selected.size) { toast('Изберете поне един ред.', true); return; }
      await a.run(Array.from(selected));
    } });
    b._label = a.label;
    return b;
  });
  const countLbl = el('span', { class: 'bulk-count', role: 'status', style: 'display:none' });
  function update() {
    const show = isAdmin && selected.size;
    delBtn.style.display = show ? '' : 'none';
    delBtn.textContent = 'Изтрий избраните (' + selected.size + ')';
    if (statusSel) statusSel.style.display = show ? '' : 'none';
    actionBtns.forEach((b) => { b.style.display = show ? '' : 'none'; b.textContent = b._label; });
    countLbl.style.display = show ? '' : 'none';
    countLbl.textContent = 'Избрани: ' + selected.size;
    selAll.checked = !!(rowCbs.length && rowCbs.every(({ cb }) => cb.checked));
  }
  // title НЕ е надеждно име за екранен четец — нужен е aria-label.
  // „Всички" = всички ПОКАЗАНИ редове (след филтрите) — точно каквото човек
  // вижда. Скритите от филтъра не се избират тайно.
  const selAll = el('input', { type: 'checkbox', 'aria-label': 'Избери всички показани редове', title: 'Избери всички показани', onClick: (e) => { const on = e.target.checked; rowCbs.forEach(({ cb, id }) => { cb.checked = on; if (on) selected.add(id); else selected.delete(id); }); update(); } });
  // ---- Бързо избиране като в Excel (Макс, 20.10.2026) ----
  // Задържате левия бутон върху отметка и плъзгате нагоре/надолу — всички
  // редове от първия до този под мишката стават като първия след натискането
  // (отметнати или размаркирани). Върнете ли мишката назад, редовете извън
  // обхвата си връщат предишното състояние — точно както в Excel.
  // Shift + натискане отмята всичко от последно натиснатата отметка дотук.
  let drag = null;      // { from, mode, before: Map(id → бил ли е избран), moved }
  let lastIdx = -1;     // за Shift + натискане
  let eatClick = false; // плъзгането е свършило върху отметка — нейният click не бива да я обърне пак
  const setRow = (i, on) => { const r = rowCbs[i]; r.cb.checked = on; if (on) selected.add(r.id); else selected.delete(r.id); };
  const idxOfNode = (n) => {
    const tr = n && n.closest ? n.closest('tr') : null;
    return tr ? rowCbs.findIndex((r) => r.td && r.td.parentElement === tr) : -1;
  };
  function paint(to) {
    const lo = Math.min(drag.from, to), hi = Math.max(drag.from, to);
    rowCbs.forEach((r, i) => setRow(i, (i >= lo && i <= hi) ? drag.mode : drag.before.get(r.id)));
    update();
  }
  function onOver(e) {
    if (!drag) return;
    const i = idxOfNode(e.target);
    if (i < 0 || (i === drag.from && !drag.moved)) return;
    drag.moved = true;
    paint(i);
  }
  function onUp() {
    if (!drag) return;
    if (drag.moved) { eatClick = true; setTimeout(() => { eatClick = false; }, 0); }
    lastIdx = drag.moved ? lastIdx : drag.from;
    drag = null;
    document.removeEventListener('mouseover', onOver, true);
    document.removeEventListener('mouseup', onUp, true);
    document.body.classList.remove('bulk-dragging');
  }
  function onDown(e, td) {
    if (e.button !== 0 || e.shiftKey) return;
    const i = rowCbs.findIndex((r) => r.td === td);
    if (i < 0) return;
    // Без маркиране на текст, докато се плъзга.
    e.preventDefault();
    drag = { from: i, mode: !rowCbs[i].cb.checked, before: new Map(rowCbs.map((r) => [r.id, r.cb.checked])), moved: false };
    document.addEventListener('mouseover', onOver, true);
    document.addEventListener('mouseup', onUp, true);
    document.body.classList.add('bulk-dragging');
  }

  return {
    isAdmin,
    toolbar: isAdmin ? [countLbl, ...actionBtns, statusSel, delBtn].filter(Boolean) : [],
    headTh: isAdmin ? el('th', { scope: 'col', style: 'width:30px' }, selAll) : null,
    reset() { selected.clear(); rowCbs.length = 0; lastIdx = -1; update(); },
    selectedIds() { return Array.from(selected); },
    // label = какво избираме (име на фирма, номер на фактура…). Без него
    // всички отметки се четат еднакво: „поле за отметка, неотметнато".
    cell(id, label) {
      if (!isAdmin) return null;
      const cb = el('input', {
        type: 'checkbox',
        'aria-label': label ? ('Избери ' + label) : 'Избери реда',
        onClick: (e) => {
          e.stopPropagation();
          if (eatClick) { e.preventDefault(); eatClick = false; return; }
          const i = rowCbs.findIndex((r) => r.cb === cb);
          if (e.shiftKey && lastIdx >= 0 && lastIdx < rowCbs.length && i >= 0) {
            const on = e.target.checked;
            for (let k = Math.min(lastIdx, i); k <= Math.max(lastIdx, i); k++) setRow(k, on);
          } else if (e.target.checked) selected.add(id); else selected.delete(id);
          lastIdx = i;
          update();
        },
      });
      const td = el('td', { class: 'bulk-cell', style: 'width:30px', title: 'Задръжте левия бутон и плъзнете, за да изберете много редове', onClick: (e) => {
        e.stopPropagation();
        // Цялата клетка е мястото за хващане — натискане до отметката също я обръща.
        if (e.target !== td) return;
        if (eatClick) { eatClick = false; return; }
        cb.click();
      } }, cb);
      td.addEventListener('mousedown', (e) => onDown(e, td));
      rowCbs.push({ cb, id, td });
      return td;
    },
  };
}

